<template>
  <div>
    <header>
      <div class="header-inner">
        <div class="logo" :style="{backgroundImage: `url('${collectionImage}')` }"></div>
        <!-- /.logo -->
      </div>
      <!-- /.header-inner -->
    </header>
    <main>
      <section class="collection-container">
        <ul>
          <li class="collection-container-title">{{collectionName}}</li>
          <li v-for="gallery in galleries">
           <router-link :to="'/gallery/'+gallery.ChildGallery.gallery_id">
              <ul>
                <li>{{gallery.ChildGallery.name}}</li>
                <li><img src="../assets/images/images.svg" width="24" height="24" alt="">Images: {{gallery.ChildGallery.Total}}</li>
                <li class="collection-gallery_link">View gallery</li>
              </ul>
            </router-link>
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>

  export default {
    name: 'collection',
    data () {
      return {
        collectionName: '',
        collectionImage: '',
        galleries: ''
      }
    },
    mounted () {

      // console.log(this.$route.name);
      // console.log(this.$route.params.id);

      var initEp = 'https://www.photoshelter.com/psapi/v3/collection/'+this.$route.params.id+'?api_key=Tc6JbbBVQfA';

      var extend = {
        "KeyImage": {
          "fields": "image_id,gallery_id",
          "params": {}
        },
        "ImageLink": {
          "fields": "link,base",
          "params": {}
        },
        "Children": {
          "ChildCollection": {
            "fields": "name",
            "params": {}
          },
        },
        "GalleryImage": {
          "fields": "",
          "params": {
            "per_page": "1",
            "page": "1"   
          }
        }
      };

      var extendStr = "extend=" + JSON.stringify(extend);
      var request = initEp + "&" + extendStr;

      axios
        .get(request)
        .then(response => {
          this.galleries = response.data.data.Collection.Children;
          // console.log(this.galleries);
          this.collectionName = response.data.data.Collection.name;
          // console.log(this.collectionName);
          this.collectionImage = response.data.data.Collection.KeyImage.ImageLink.base;
          // console.log(this.collectionImage);       
        })

    }
  }

</script>

<style lang="scss" scoped>

  @import '../assets/scss/_variables';
  @import '../assets/scss/_include-media';
  @import '../assets/scss/components/_admin-collection';

  ul {
    li.collection-container-title {
      border: none;
      padding-bottom: $spacing;
      &:last-child {
        border: none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/collection.vue